import React, { useCallback, useEffect, useMemo, useState } from 'react'
import TransaksiService from '../../../../../services/transaksi/TransaksiService'
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap'
import { FaSave } from 'react-icons/fa'
import SweetAlert from 'react-bootstrap-sweetalert'

const ModalViewMutuProduksi = ({ showMutuProduksi, handleCloseMutuProduksi, nomorAju, dataProduksi, reloadList, isEdit }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])

    const [valueMutuProdNo, setValueMutuProdNo] = useState(null)
    const [valueMutuProdTgl, setValueMutuProdTgl] = useState(null)
    const [valueMutuProdSeri, setValueMutuProdSeri] = useState(null)

    const onChangeMutuProdNo = e => {
        setValueMutuProdNo(e.target.value)
    }

    const onChangeMutuProdTgl = e => {
        setValueMutuProdTgl(e.target.value)
    }

    const fetchAllData = useCallback(async () => {
        if (!dataProduksi?.trPpkMutuProdPK.nomorAju) {
            return
        }

        try {
            setValueMutuProdNo(dataProduksi.mutuProdNo)
            setValueMutuProdTgl(dataProduksi.mutuProdTgl)
            setValueMutuProdSeri(dataProduksi.trPpkMutuProdPK.mutuProdSeri)
        } catch (error) {

        }
    }, [dataProduksi])

    useEffect(() => {
        let isMounted = true;
        if (!dataProduksi) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [dataProduksi, fetchAllData])

    const handleClickClose = () => {
        setValueMutuProdNo('')
        setValueMutuProdTgl('')
        setValueMutuProdSeri(null)
        reloadList(1)
        handleCloseMutuProduksi()
    }

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSimpan, setShowConfirmSimpan] = useState(false)
    const handleCloseConfirmSimpan = () => setShowConfirmSimpan(false)
    const handleShowConfirmSimpan = () => setShowConfirmSimpan(true)
    const [showSimpanSuccess, setShowSimpanSuccess] = useState(false)
    const [showSimpanFailed, setShowSimpanFailed] = useState(false)

    const handleClickSimpan = async () => {
        setLoadingSave(true)
        try {
            const resNextSeri = await transaksiService.nextSeri('mutuprod', nomorAju)
            let jsonProd = {
                ...dataProduksi,
                trPpkMutuProdPK: {
                    nomorAju: nomorAju,
                    mutuProdSeri: valueMutuProdSeri !== null && valueMutuProdSeri !== '' ? valueMutuProdSeri : resNextSeri.data
                },
                mutuProdNo: valueMutuProdNo,
                mutuProdTgl: valueMutuProdTgl
            }
            const response = await transaksiService.addPpmMutuProd(jsonProd)
            if (response.data.kode === '200') {
                setShowSimpanSuccess(true)
                setShowConfirmSimpan(false)
            } else {
                setShowSimpanFailed(true)
                setShowConfirmSimpan(false)
            }
        } catch (error) {
            setShowSimpanFailed(true)
            setShowConfirmSimpan(false)
        }
        setLoadingSave(false)
    }

    const handleClickSimpanSuccess = () => {
        setShowSimpanSuccess(false)
        setValueMutuProdNo('')
        setValueMutuProdTgl('')
        setValueMutuProdSeri(null)
        reloadList(1)
        handleCloseMutuProduksi()
    }

    const handleClickSimpanFailed = () => {
        setShowSimpanFailed(false)
    }

    return (
        <>
            <Modal
                show={showMutuProduksi}
                onHide={handleCloseMutuProduksi}
                size='md'
                centered
                backdrop='static'
            >
                <Modal.Header>
                    <Modal.Title><h6>Data Produksi</h6></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className='form-group'>
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Kode Produksi <span className='text-danger'>*</span></Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="text" placeholder="Kode Produksi " className="form-control-sm" value={valueMutuProdNo} onChange={onChangeMutuProdNo} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12'>
                            <Form>
                                <Form.Group as={Row} className='form-group'>
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Tanggal Produksi <span className='text-danger'>*</span></Form.Label>
                                    <Col sm="8">
                                        <Form.Control type="date" placeholder="Tanggal Produksi" className="form-control-sm" value={valueMutuProdTgl} onChange={onChangeMutuProdTgl} disabled={!isEdit} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {isEdit && <Button variant="primary" size="sm" onClick={() => handleShowConfirmSimpan()}><FaSave /> Simpan</Button>}{' '}
                    <Button variant="danger" size="sm" onClick={() => handleClickClose()}>Batal</Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmSimpan &&
                <SweetAlert
                    title="Simpan Data Produksi?"
                    warning
                    showCancel
                    confirmBtnText={
                        loadingSave ? (
                            <>
                                <Spinner animation="border" size="sm" className="me-2" />
                                Proses Simpan...
                            </>
                        ) : (
                            "Simpan"
                        )
                    }
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickSimpan}
                    onCancel={handleCloseConfirmSimpan}
                    focusCancelBtn
                    btnSize="sm"
                    disabled={loadingSave}
                >
                    {loadingSave && (
                        <div className="text-center">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                        </div>
                    )}
                </SweetAlert>
            }
            {
                showSimpanSuccess &&
                <SweetAlert
                    success
                    title="Simpan Data Produksi Berhasil"
                    onConfirm={handleClickSimpanSuccess}
                    btnSize="sm"
                />
            }
            {
                showSimpanFailed &&
                <SweetAlert
                    danger
                    title="Simpan Data Produksi Gagal"
                    onConfirm={handleClickSimpanFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
        </>
    )
}

export default ModalViewMutuProduksi